import { Icon, IconProps } from '@chakra-ui/react'

export default function SessionsIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#323232'}
      {...props}
    >
      <path
        d="M7.99664 7.99854H6.70429C6.23837 7.99854 5.77885 8.107 5.36212 8.31538L4.77667 8.6081C4.26617 8.86333 3.83904 9.25885 3.54539 9.74826L1.99414 12.3337"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0028 13.0007H17.002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0017 16.0017H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99609 21.004L8.76036 18.9212C9.5649 18.6304 10.2551 18.0896 10.7297 17.3778L13.7238 12.888C14.1593 12.235 14.0733 11.3654 13.5183 10.8103V10.8103C12.8754 10.1675 11.8331 10.1674 11.1901 10.8101L8.99859 13.0007H6.99776"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99805 19.1966V19.5035C7.99805 20.3322 8.6699 21.0041 9.49867 21.0041H20.5033C21.332 21.0041 22.0039 20.3322 22.0039 19.5035V4.49721C22.0039 3.66843 21.332 2.99658 20.5033 2.99658H9.49867C8.6699 2.99658 7.99805 3.66843 7.99805 4.49721V13.0007"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 6.2C20 6.03431 19.8657 5.9 19.7 5.9H19.1V5.3C19.1 5.13431 18.9657 5 18.8 5H18.2C18.0343 5 17.9 5.13431 17.9 5.3V5.9H17.3C17.1343 5.9 17 6.03431 17 6.2V6.8C17 6.96569 17.1343 7.1 17.3 7.1H17.9V7.7C17.9 7.86568 18.0343 8 18.2 8H18.8C18.9657 8 19.1 7.86568 19.1 7.7V7.1H19.7C19.8657 7.1 20 6.96569 20 6.8V6.2Z"
        stroke="currentColor"
        strokeWidth="0.59975"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
